import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useResizeObserver } from '../containers/HomeContainerNew/helper';

const ContainerWidthContext = createContext(0);

export const ContainerWidthProvider = ({ children }) => {
    const containerRef = useRef(null);
    const width = useResizeObserver(containerRef);

    useEffect(
        () => {
            if (width !== 0) {
                document.documentElement.style.setProperty(
                    '--container-width',
                    `${width}px`
                );
            }
        },
        [width]
    );

    return (
        <ContainerWidthContext.Provider value={width}>
            <div ref={containerRef}>{children}</div>
        </ContainerWidthContext.Provider>
    );
};

export const useContainerWidth = () => useContext(ContainerWidthContext);
